import { Button, Col, Empty, Flex, Row } from "antd";
import { ApiService } from "api/api.service";
import PageTitle from "components/PageTitle";
import DashboardLayout from "layout/DashboardLayout";
import { useState } from "react";
import { storedTokens } from "utils/storedTokens";
import { CreatePipelineModal } from "./CreatePipelineModal";
import { BoardCard, BoardCardSkeleton } from "./BoardCard";
import { useNavigate, useSearchParams } from "react-router-dom";
import { OrgSelector } from "components/Organisation/OrganisationSelector";

export const PipelineBoards = () => {
  const [sp, setSp] = useSearchParams();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const organisations = ApiService.organisation.useGetAllOrganisations();
  const [selectedOrg, setSelectedOrg] = useState(() => {
    const queryOrgCode = sp.get("orgCode");
    return (queryOrgCode || storedTokens.orgCode.getToken()) ?? undefined;
  });
  const boards = ApiService.kanban.useGetBoards(selectedOrg);
  const navigate = useNavigate();

  return (
    <DashboardLayout
      headerRight={
        <Flex gap={8}>
          <Button onClick={() => setOpenCreateModal(true)} variant="solid" color="purple">
            Create New Pipeline
          </Button>
          <OrgSelector
            selected={selectedOrg}
            onChange={(org) => {
              setSp((prev) => ({ ...prev, orgCode: org.code }));
              setSelectedOrg(org.code);
            }}
            organisations={organisations.data ?? []}
          />
        </Flex>
      }
    >
      <PageTitle pageTitle={[{ title: "Pipelines" }]} title="Pipeline" />
      {boards.data?.length ? (
        <Row gutter={[16, 16]} className="p-4">
          {boards.data?.map((board) => (
            <Col key={board._id} xs={24} sm={12} md={8} lg={8} xl={6}>
              <BoardCard
                board={board}
                refetch={boards.refetch}
                onClick={() => {
                  navigate(`/dashboard/operations/pipelines/${board._id.toLowerCase()}`);
                }}
              />
            </Col>
          ))}
        </Row>
      ) : boards.isLoading ? (
        <Row gutter={[16, 16]} className="p-4">
          {Array.from({ length: 4 }).map((_, idx) => (
            <Col key={idx} xs={24} sm={12} md={8} lg={8} xl={6}>
              <BoardCardSkeleton />
            </Col>
          ))}
        </Row>
      ) : (
        <Empty className="mt-48" image={Empty.PRESENTED_IMAGE_DEFAULT} description="No Boards Found!" />
      )}
      <CreatePipelineModal
        open={openCreateModal}
        onOk={() => {
          setOpenCreateModal(false);
          boards.refetch();
        }}
        onCancel={() => setOpenCreateModal(false)}
        initialOrgCode={selectedOrg}
      />
    </DashboardLayout>
  );
};

export default PipelineBoards;
